/**
 * Удаление лоадера из dom дерева после загрузки страницы
 * Скрипт отрабатывает в любом случае, даже если есть ошибки в JS
 */
window.onload = function() {
    let loader = document.querySelector('.loader');
    loader.parentNode.removeChild(loader);
};


$(document).ready(function() {
    /** Глобальные переменные */
    var WIN = $(window),
        DOC = $(document),
        HTML = $('html');

    /** Определяем браузеры Internet Explorer 11 и Edge */
    let ua = window.navigator.userAgent,
        edge_ua = ua.indexOf('Edge/'),
        ie_ua = ua.indexOf('Trident/7.0'),
        edge = 'edge',
        ie = 'ie';
    if (edge_ua > 0) {
        HTML.addClass(edge);
    }
    if (ie_ua + 1) {
        HTML.addClass(ie);
    }



    /** Добавляем стили и скрипты для браузера Internet Explorer 11 */
    if (HTML.hasClass(ie)) {
        HTML.append('<script src="../../js/' + ie + '.js"></script>');
        HTML.append('<link href="../../css/' + ie + '.css" rel="stylesheet">');
    }


    /** TMP class for promo page **/
    if($('.page-main').length > 0){
      $('main.main').addClass('main-promo');
    }

    /** Рейтинг игры на странице Demo game **/
    var rating = $('[data-rating]');
    var isLogged = rating.data('logged') ? true : false;


    rating.rating({
        fx: 'half',
        image: '/img/elements/stars.png',
        loader: '/img/elements/ajax-loader.gif',
        readOnly: isLogged
    });
    if(isLogged){
        $('.vote-hover').css({
            'cursor':'default'
        });
    }
    /** End Рейтинг игры на странице Demo game **/

    /** Слайдер победителей в турнирах **/
    var prizeSlider = new Swiper('[data-tournament-prize] .swiper-container', {
        speed: 1000,
        loop: false,
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 40,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '[data-tournament-prize] .icon-button-next',
            prevEl: '[data-tournament-prize] .icon-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 1
            },
            580: {
                slidesPerView: 2
            },
            980: {
                slidesPerView: 3
            },
            1440: {
                slidesPerView: 4
            },
        }
    });
    /** End слайдер новостей на главной **/

    /** Cлайдер на главной странице */
    var homepageSlider = new Swiper('[data-slider-homepage]', {
        speed: 1000,
        slidesPerView: 3,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        centeredSlides: true,
        loop: true,
        preloadImages: true,
        lazy: true,
        breakpoints: {

            1440: {
                slidesPerView: 'auto'
            }
        }
    });

    /** Cлайдер на странице c играми */
    var mainSlider = new Swiper('[data-slider-main]', {
        speed: 1000,
        slidesPerView: 1,
        slidesPerGroup: 1,
	    loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        effect: 'fade',
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });


    /** Cлайдер game menu */
    $('[data-slider-menu]').each(function() {
        // используемые классы
        let name = $(this);

        let menuSlider = new Swiper(name.find('.swiper-container'), {
            slidesPerView: 'auto',
            freeMode: true,
            slideClass: 'games__menu-item',
            scrollbar: {
                el: name.find('.swiper-scrollbar'),
                hide: false
            }
        });
    });


    /** Slider game-type menu */

    var gametypeSlider = new Swiper('[data-slider-type-menu]', {
        slidesPerView: 9,
        breakpoints: {
            360: {
                slidesPerView: 2.5
            },
            480: {
                slidesPerView: 3.5
            },
            640: {
                slidesPerView: 4.5
            },
            980: {
                slidesPerView: 5.5
            },
            1220: {
                slidesPerView: 6.5
            },
        }
    });

    // ----- SPORT BOOK top menu slider

	function sliderSportMenu() {
		if (WIN.width() <= 768) {
			var gametypeSliderSport = new Swiper('[data-slider-type-menu-sport]', {
				slidesPerView: 4.5,
				spaceBetween: 0,
				breakpoints: {
					380: {
						slidesPerView: 2
					},
					500: {
						slidesPerView: 2.5
					},
					680: {
						slidesPerView: 3.5
					},
				}
			});
		}
		if (WIN.width() > 768) {
			var gametypeSliderSport = new Swiper('[data-slider-type-menu-sport]', {
				slidesPerView: 9,
				spaceBetween: 0,
				width: 1920,
				breakpoints: {
					980: {
						width: 710,
						slidesPerView: 4.5
					},
					1220: {
						width: 910,
						slidesPerView: 4.5
					},
					1299: {
						width: 1200,
						slidesPerView: 7
					},
					1599: {
						width: 1300,
						slidesPerView: 7
					},
					1799: {
						width: 1600,
						slidesPerView: 9
					},
					1919: {
						width: 1800,
						slidesPerView: 9
					},
				}

			});
		}

	}

	sliderSportMenu();

	WIN.on('resize', function() {
		sliderSportMenu();
	});



	/** Slider slotor submenu **/

    var swiperSlotsSubmenu = new Swiper('[data-slider-slots-nav]', {
        slidesPerColumnFill  : 'row',
        slidesPerView        : 4,
        slidesPerColumn      : 6,
		pagination: {
			el: '[data-slider-slots-pag]',
			clickable: true,
		},
		breakpoints: {
			480: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 3,
			}
		}
	});

	$('[data-slots-active]').click(function () {
		$(this).parent('li').toggleClass('active');
		$('[data-slots-menu]').toggleClass('active');
	});

    /** Слайдер игр на главной **/

    $('[data-games-slider]').each(function() {
        // используемые классы
        let name = $(this);

        let gameSlider = new Swiper(name.find('.swiper-container'), {
            loop: false,
            centeredSlides: false,
            slideClass: 'games__item',
            slidesPerView: 5,
            slidesPerGroup: 1,
            spaceBetween: 10,
            pagination: {
                el: name.find(' .swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                1220: {
                    slidesPerView: 'auto',
                    loop: true,
                    centeredSlides: true
                }
            }
        });
    });


    /** Слайдер победителей на главной **/
    var winnersSlider = new Swiper('[data-slider-winners]', {
        direction: 'vertical',
        //loop: true,
        speed: 1000,
        slidesPerView: 6,
        spaceBetween: 0,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },

        breakpoints: {
            980: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            1220: {
                slidesPerView: 5,
                slidesPerGroup: 5
            },
        }
    });
    /**  End Слайдер победителей на главной **/

	/** Слайдер победителей на стр игры **/
	var gameWinnersSlider = new Swiper('[data-slider-game-winners]', {
		direction: 'vertical',
		loop: true,
		speed: 1000,
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false
		},
	});
	/**  End Слайдер победителей на стр игры **/

    /** Слайдер новостей на главной **/
    var newsSlider = new Swiper('[data-news-slider] .swiper-container', {
        speed: 1000,
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '[data-news-slider] .swiper-pagination',
            clickable: true
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 2,
                slidesPerGroup: 2
            }
        }
    });
    /** End слайдер новостей на главной **/

    /** Слайдер турнирных игр на странице турниры и турнир **/

    $('[data-recent-games-slider]').each(function() {
        // используемые классы
        let name = $(this);
        let recentSlider = new Swiper(name.find('.swiper-container'), {
            speed: 1000,
            slideClass: 'games-recent__item',
            slidesPerView: 5,
            slidesPerGroup: 1,
            spaceBetween: 25,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false
            },

            breakpoints: {
                480: {
                    slidesPerView: 1,
                    slidesPerGroup: 1

                },
                980: {
                    slidesPerView: 2,
                    slidesPerGroup: 2

                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                1440: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            }
        });
    });

    /** Слайдер выбора бонуса на депозит в модалке **/
    function chooseBonus() {
        $('[data-choose-bonus-slider]').each(function() {
            let name = $(this);
            if (name.length > 0 && name.is(':visible') && name.find('.swiper-slide-active').length < 1) {
                // используемые классы
                let chooseSlider = new Swiper(name.find('.swiper-container'), {
                    slideClass: 'bonuses__item',
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0,
                    pagination: {
                        el: name.find ('.swiper-pagination'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: name.find(' .slider-arrow--next'),
                        prevEl: name.find(' .slider-arrow--prev'),
                    }
                });
            }

        });
    }
    chooseBonus();

    /**  Search input **/

    $('.search').click(function(){
        $(this).toggleClass('active');
        $(this).next('.search-bar').toggleClass('active');

        // $('.search-bar input').focus();
    });

    /**  End search input **/


    /** Tabs + cookie / profile: bonuses player page -------------- **/
    function bonusesSwitcher(e) {
        const bonusesActive = $('[data-bonuses-active]');
        const bonusesActiveContent = $('[data-bonuses-active-content]');

        const bonusesAvailable = $('[data-bonuses-available]');
        const bonusesAvailableContent = $('[data-bonuses-available-content]');

        bonusesAvailable.on('click', function() {
            bonusesActive.removeClass('active');
            bonusesActiveContent.removeClass('active');
            bonusesAvailable.addClass('active');
            bonusesAvailableContent.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-available', {
                path: '/'
            });
            lazyLoad();
        });

        bonusesActive.on('click', function() {
            bonusesAvailable.removeClass('active');
            bonusesAvailableContent.removeClass('active');
            bonusesActive.addClass('active');
            bonusesActiveContent.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-active', {
                path: '/'
            });
            lazyLoad();
        });
    }

    bonusesSwitcher();
    /** End Tabs profile bonuses **/


    /**
     * Стилизация скроллабара в блоках
     */
    $('[data-scrollbar]').scrollbar({
        "showArrows": true,
        "scrolly": 'advanced',
        "ignoreOverlay": true
    });

    $('.scroll-wrapper').each(function() {
        setTimeout(function() {
            if ($(this).height() < $(this).parent().height()) {
                $(this).addClass('scroll--void').find('.scroll-element').hide();
            }
        }, 100);
    });





    /** ADD cookies profile bonuses switcher **/
    function setBonusesView() {
        if ($.cookie('BonusesSwitcher') == null) {
            $.cookie('BonusesSwitcher', 'bonuses-available', {
                path: '/'
            });
        }
        if ($.cookie('BonusesSwitcher') == 'bonuses-available') {
            $('[data-bonuses-available]').click();
        }

        if ($.cookie('BonusesSwitcher') == 'bonuses-active') {
            $('[data-bonuses-active]').click();
        }
    }

    setBonusesView();
    /** END ADD cookies profile bonuses switcher **/


    /**  accordion / game page **/
    DOC.on('click', '.accordion__item-header', function() {
        var item = $(this).parents('.accordion__item');
        item.siblings().removeClass('accordion__item--open');
        item.toggleClass('accordion__item--open');
    });
    /** end accordion / game page **/

	/** Описание игры **/
	// $('.show-more').click(function() {
	// 	$('.game-info__description').toggleClass("open");
	// 	//$(this).toggleClass("rotate");
	// });
	/** End Описание игры **/


    /** jackpots counter for numbers **/
    $('[data-jackpots-counter]').countUp();
    /** end jackpots counter for numbers **/

    /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
    var shortText= $('[data-cut-text]');
    shortText.each(function(){
        var size = $(this).data('cutText'),
            elementText = $(this).text();
        if(elementText.length > size){
            $(this).text(elementText.slice(0, size) + ' ...');
        }
    });


    /** Описание бонуса с flip-эффекто **/
    $('[data-bonus-fliper]').click(function() {
        var bonus = $(this).parents('[data-bonus-flip]');
        bonus.toggleClass('flip');
    });
    /** End **/

    /** Mobile tables **/
    (function() {
        var headertext = [];
        var headers = document.querySelectorAll("thead");
        var tablebody = document.querySelectorAll("tbody");

        for (var i = 0; i < headers.length; i++) {
            headertext[i] = [];
            for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
                var current = headrow;
                headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
            }
        }
        if (headers.length > 0) {
            for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                for (var i = 0, row; row = tbody.rows[i]; i++) {
                    for (var j = 0, col; col = row.cells[j]; j++) {
                        col.setAttribute("data-label", headertext[h][j]);
                    }
                }
            }
        }
    }());
    /** End Mobile tables **/

    /** List to Grid view for tables **/
    function viewSwitcher(e) {
        const listButton = $('[data-view-table]');
        const gridButton = $('[data-view-grid]');
        const wrapper = $('.table');
        listButton.on('click', function() {
            gridButton.removeClass('active');
            listButton.addClass('active');
            wrapper.removeClass('table-grid').addClass('table-list');
            $.cookie('TableView', 'table-view', {
                path: '/'
            });
        });
        gridButton.addClass('active');
        gridButton.on('click', function() {
            listButton.removeClass('active');
            gridButton.addClass('active');
            wrapper.removeClass('table-list').addClass('table-grid');
            $.cookie('TableView', 'grid-view', {
                path: '/'
            });
        });
        setTimeout(function() {
            if (WIN.width() <= 768) {
                wrapper.removeClass('table-list').addClass('table-grid');
            }
        }, 200);
        WIN.on('resize', function() {
            if (WIN.width() <= 768) {
                wrapper.removeClass('table-list').addClass('table-grid')
            }
            if (WIN.width() > 768 && $("[data-view-table]").hasClass('active')) {
                wrapper.removeClass('table-grid').addClass('table-list')
            }
        });
    }
    viewSwitcher();

    /** End List to Grid view for tables **/


    /** profile-menu toggler for open/close **/

    DOC.on('click', '[data-profile-menu]:not(.opened) i', function(event) {
        event.preventDefault();
        $('[data-profile-menu]').addClass('opened');
        $('[data-profile-menu-closer] i').removeClass('icon-menu').addClass('icon-menu-close');
    });
    DOC.on('click', '[data-profile-menu].opened [data-profile-menu-closer]', function() {
        $('[data-profile-menu]').removeClass('opened');
        $('[data-profile-menu-closer] i').removeClass('icon-menu-close').addClass('icon-menu');
    });
    /** end profile-menu toggler for open/close **/


    /** ADD cookies List to Grid view for tables **/
    function setTableView() {
        if ($.cookie('TableView') == null) {
            $.cookie('TableView', 'grid-view', {
                path: '/'
            });
        }
        if ($.cookie('TableView') == 'grid-view') {
            $('[data-view-grid]').click();
        }
        if ($.cookie('TableView') == 'table-view') {
            $('[data-view-table]').click();
        }
    }
    setTableView();
    /** END ADD cookies List to Grid view for tables **/


    /** Реализация адаптивности iframe в статьях **/
    $('.article__content iframe').each(function() {
        $(this).wrap('<div class="videowrapper">');
    });
    /** end **/


    /** Инициализация типовых модалок **/
    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            open: function() {
                //$('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
            },
            close: function() {
                $('.header').css('width', '100%')
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End Инициализация модалок **/

    /** Инициализация модального окна, которое невозможно закрыть */
    $('[data-modal--immortal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        closeOnBgClick: false,
        showCloseBtn: false,
        enableEscapeKey: false,
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            open: function() {
                $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
            },
            close: function() {
                $('.header').css('width', '100%')
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End **/

    /** Инициализация модального окна, которое невозможно закрыть */
    $('[data-modal--loader]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        closeOnBgClick: false,
        showCloseBtn: false,
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            open: function() {
                $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
            },
            close: function() {
                $('.header').css('width', '100%')
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End **/

    /**
     * Появление и скрытие поля с ответом на секретный вопрос
     * Появление\скрытие инпута в инициализации selectric'a
     **/
    let secret_question = $('.secret_question'),
        secret_answer = $('.secret_answer');
    if (!secret_question.val()) {
        secret_answer.hide();
    }
    /** End **/

    /**
     * Инициализация select menu
     * Используется в формах, которые подгружаются на ajax
     * Для этого вынесен в функцию для использования внутри ajaxSuccess
     **/
    function selectInit() {
        $('[data-select-menu]').each(function() {
            if (!$(this).parent().hasClass('selectric-hide-select')) {
                $(this).selectric({
                    maxHeight: 200,
                    disableOnMobile: false,
                    nativeOnMobile: false,
                    onInit: function() {
                        var current_option = $(this),
                            current_option_value = current_option.val(),
                            selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                        // проверка для вывода поля с секретным ответом
                        if (current_option.hasClass('secret_question')) {
                            if (current_option_value) {
                                secret_answer.show();
                            } else {
                                secret_answer.hide();
                            }
                        }

                        //  эмуляция placeholder'a для селектрика
                        if (current_option_value) {
                            selectric_container.removeClass('selectric--placeholder');
                        } else {
                            selectric_container.addClass('selectric--placeholder');
                        }

                        // проверка на количество эллементов, если 1 - то добавляем класс,
                        // который скрывает всю навигацию
                        if (current_option.find('option').length === 1) {
                            current_option.parents('.selectric-wrapper').addClass('selectric--void');
                        }
                    },
                    onChange: function(element) {
                        var current_option = $(this),
                            current_option_value = current_option.val(),
                            selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                        // проверка для вывода поля с секретным ответом
                        if (current_option.hasClass('secret_question')) {
                            if (current_option_value) {
                                secret_answer.show();
                            } else {
                                secret_answer.hide();
                            }
                        }

                        //  эмуляция placeholder'a для селектрика
                        if (current_option_value) {
                            selectric_container.removeClass('selectric--placeholder');
                        } else {
                            selectric_container.addClass('selectric--placeholder');
                        }
                    },
                });
            }
        });
    }
    selectInit();
    /** End **/

    /** Меню провайдеров в селектменю **/
    $('[data-select-provider-menu]').selectric({
        maxHeight: 200,
        disableOnMobile: false,
        nativeOnMobile: false,
        responsive: false,
        onInit: function() {
            if ($(this).find('option').length === 1) {
                $(this).parents('.selectric-wrapper').addClass('selectric--void');
            }
        }
    }).on('change', function() {
        location.href = $(this).val();
    });
    /** End **/

    /** Инициализация select menu валют **/
    $('[data-select-currency]').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onInit: function() {
            if ($(this).find('option').length === 1) {
                $(this).parents('.selectric-wrapper').addClass('selectric--void');
            }
        }
    }).on('change', function() {
        location.href = $(this).val();
    });
    /** End Инициализация select menu валют **/

    /** Fix для пагинации таблиц в кабинете игрока (решение под вопросом, костыль из-за бэкендеров) **/
    DOC.on('click', '.pager__item a', function(event) {
        $('html, body').animate({
            scrollTop: $('#table-top').offset().top
        }, 500);
    });
    /** End Fix для пагинации таблиц в кабинете игрока **/

    /** Fix Hover on mobile **/
    fixHover('.games__item', '.games__item__overlay', 'games__item__overlay--active');

    function fixHover(sSelestor, sHover, sActiveClass) {
        $(sSelestor).hover(
            function() {
                $(this)
                    .find(sHover)
                    .addClass(sActiveClass);
            },
            function() {
                $(this)
                    .find(sHover)
                    .removeClass(sActiveClass);
            }
        );
    }
    /** End Fix Hover on mobile **/


    /**
     * Инициализация поля выбора даты
     * Используется в формах, которые подгружаются на ajax
     * Для этого вынесен в функцию для использования внутри ajaxSuccess
     **/
    function dateInit() {
        let input_date = $('[data-datepicker]');
        if (input_date.length > 0 && input_date.is(':visible')) {
            if (!$('.datepickers-container').length) {
                let date = (new Date()).getFullYear();
                let maxdate = new Date();
                maxdate.setYear(date - 18);

                input_date.datepicker({
                    maxDate: maxdate,
                    autoClose: true,
                    dateFormat: 'yyyy-mm-dd',
	                language: $('html').attr('lang')
                });
            }
        }
    }

    dateInit();
    /** End **/

    /** Avatar load в профиле Игрока **/
    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function(e) {
                $('.profile-pic').attr('src', e.target.result);
            };
            reader.readAsDataURL(input.files[0]);
        }
    };
    $('#avatar-form').submit(function() {
        readURL($('#avatar-input'));
    });

    $("[data-avatar-submit]").on('click', function() {
        $("[data-avatar-upload]").click();
    });

    /** End Avatar load в профиле Игрока **/

    /** Document load в кабинете Игрока **/
    $(".upload-button").on('click', function() {
        $(".file-upload").click();
    });
    /** End Document load в кабинете Игрока **/



    /** Profile **/

    var swiperProfileTabs = new Swiper('[data-profile-tabs]', {
	    slidesPerView: 6,
	    spaceBetween: 0,
	    navigation: {
		    nextEl: '[data-profile-tabs-next]',
		    prevEl: '[data-profile-tabs-prev]',
	    },
        breakpoints: {
            400: {
                slidesPerView: 1,
            },
            540: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
	        1000: {
                slidesPerView: 4,
            }
        }
    });

	$('[data-profile-tabs] ul').on('click', 'li:not(.active)', function() {
		$(this).addClass('active').siblings().removeClass('active');
	});

	$('[data-profile-tabs] .swiper-slide').each(function() {
		if ($(this).hasClass('active')) {
			swiperProfileTabs.slideTo($(this).index(), 0);
		}
	});

	/** END Profile **/

	/** Profile user info **/

	$('[data-user-info-tabs] ul').on('click', 'li:not(.active)', function() {
		$(this).addClass('active').siblings().removeClass('active').closest('[data-user-info-tabs]').find('div.profile-tab__content').removeClass('active').eq($(this).index()).addClass('active');
	});

	/** END Profile user info **/


    /** Tabs для форм на странице профиля игрока **/
    $('ul.tabs').on('click', 'li:not(.active)', function() {
        $(this).addClass('active').siblings().removeClass('active').closest('section.page-profile__content').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
        lazyLoad();
    });
    /** End Tabs история транзакций **/

    /** !!! определить необходимость для данного проекта !!! **/
    DOC.on('click', '[data-sidebar-toggler]', function() {
        var sidebar = $('[data-sidebar]');
        $(this).toggleClass('active')
        sidebar.slideToggle();
        sidebar.toggleClass('open');
    });
    /** !!! определить необходимость для данного проекта !!! **/


    /** Определяем ширину скроллбара в текущем браузере !!! определить необходимость для данного проекта !!!????? **/
    var div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';

    document.body.appendChild(div);
    var scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    /** End Определяем ширину скроллбара в текущем браузере **/


    /** Событие клика на элементе faq. Показывает\скрывает ответ на вопрос */
    DOC.on('click', '[data-faq-question]', function() {
        var item = $(this).parents('.faq__item');
        item.find('.faq__answer').slideToggle();
        item.toggleClass('faq--open');
    });
    /** End **/

    /** Иниализация отложенной подгрузки изображений + замена битого изображения логотипом проекта */
    function lazyLoad() {
        $('[data-lazy] img[data-src]').Lazy({
            scrollDirection: 'vertical',
            effect: "fadeIn",
            effectTime: 1000,
            // threshold: 0,
            // visibleOnly: false,
            onError: function(element) {
                element.attr("src","/front/img/elements/no-img.png").addClass('no-photo');
            }
        });
    }
    lazyLoad();
    /** End **/

    /** NEWS Img */
    function lazyLoadNews() {
        $('[data-lazy-news] img[data-src]').Lazy({
            scrollDirection: 'vertical',
            effect: "fadeIn",
            effectTime: 1000,
            // threshold: 0,
            // visibleOnly: false,
            onError: function(element) {
                element.attr("src","/front/img/news/no-img-news.png").addClass('no-photo');
            }
        });
    }
    lazyLoadNews();
    /** End **/


    /** Событие смены видимости пароля в инпуте */
    var passwordToggler = ('[data-password-toggler]');
    DOC.on('click', passwordToggler, function() {
        var btn = $(this),
            input = $(this).parent().find($('[data-password-input]'));
        btn.toggleClass('icon-view');
        btn.toggleClass('icon-hide');
        if (input.attr('type') == 'text') {
            input.attr('type', 'password');
        } else {
            input.attr('type', 'text');
        }
    });
    /** End **/

    /** Инициализация плагина обратного отсчета */

    $('[data-time]').each(function() {
        $(this).countdown($(this).attr('data-time'), function(event) {
            $(this).html(event.strftime('' +
                '<div class="counter__block">' +
                '<span class="counter__value">%D</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-days') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%H</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-hours') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%M</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-min') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%S</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-sec') +
                '</span>' +
                '</div>'
            ));
        });
    });

    $('[data-time-bonus]').each(function() {
        $(this).countdown($(this).attr('data-time-bonus'), function(event) {
            $(this).html(event.strftime('' +
                '<div class="counter__block">' +
                '<span class="counter__value">%D</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-days') +
                '</span>' +
                '</div>' +
                '<dl>/</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%H</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-hours') +
                '</span>' +
                '</div>' +
                '<dl>/</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%M</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-min') +
                '</span>' +
                '</div>'
            ));
        });
    });
    /** End **/

    /** Инициализация плагина обратного отсчета в модалке */

    function timeoutModal() {
        $('[data-time]').each(function() {
            $(this).countdown($(this).attr('data-time'), function(event) {
                $(this).html(event.strftime('' +
                    '%D' +
                    $(this).attr('data-days') +
                    ' : %H' +

                    $(this).attr('data-hours') +

                    ' : %M' +

                    $(this).attr('data-min') +
                    ' : %S' +

                    $(this).attr('data-sec')

                ));
            });
        });
    }

    $(document).on('ajaxSuccess', function() {
        timeoutModal();
    });


    /** End **/


    /** Tabs для формы регистрации **/
    $('ul.registration__tabs--top').on('click', 'li:not(.active)', function() {
        $(this).addClass('active').siblings().removeClass('active').closest('div.registration__tabs').find('div.registration__tabs--content').removeClass('active').eq($(this).index()).addClass('active');
        // if ($('[data-phone-tab]').hasClass('active')) {
        //     phoneInit();
        // }
    });
    /** End **/

    /** Маска для телефонного инпута **/

    // $(function($){
    //     $("input[type='tel']").mask("+(99) 99999-99999", {autoclear: false});
    // });

    /** End **/

	/** Инициализация тел. номера **/

	var input = document.querySelector("[data-phone-number]");


	if ($("[data-phone-number]").length) {
        window.intlTelInput(input, {
            initialCountry: "auto",
            autoHideDialCode: false,
            nationalMode: false,
            // separateDialCode: true,
            // hiddenInput: "full_phone",
            numberType: "MOBILE",
            preferredCountries: ["ru", "ua", "by", "kz"],
            geoIpLookup: function(callback) {
                $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "";
                    callback(countryCode);
                });
            },
            utilsScript: "/front/js/utils.js"
        });
	}

	/** End **/


    /** Tabs с дополнительной инофрмацией на странице отдельной игры **/
    $('[data-game-tabs]').on('click', 'li:not(.active)', function() {
        $(this).addClass('active').siblings().removeClass('active').closest('div.game__box--right')
            .find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
        if ($('[data-tabs-tournament]').hasClass('active')) {
            $('[data-topinfo]').addClass('open');
        } else {
            $('[data-topinfo]').removeClass('open');
        }
    });
    /** End **/

    /**
     * Условие проверки входа через IE
     * И вывод соответствующего сообщения об устаревшем браузере
     **/
    if (!HTML.hasClass('ie')) {
        $('.ieOff').remove();
    }
    /** End **/

    /**
     * Детектирование включенного AdBlock'a у пользователя
     * Если он активирован - выводим сообщение
     * При закрытии этого сообщение результат записываем в sessionStorage
     * и в следующий раз уже не отображаем сообщение
     **/
        //sessionStorage.clear();  // очищаем sessionStorage и показываем уведомление при каждой перезагрузке

    let alert_container = $('.alert');
    function adBlockDetected() {
        let alert_status = sessionStorage.getItem('alert');
        if (alert_status !== '0') {
            alert_container.show();
        }
    }
    if (typeof fuckAdBlock === 'undefined') {
        adBlockDetected();
    } else {
        fuckAdBlock.onDetected(adBlockDetected);
    }
    DOC.on('click', '[data-alert-close]', function() {
        alert_container.hide();
        sessionStorage.setItem('alert', '0');
    });

    /** Language select **/
    DOC.on('click', '.lang-select', function() {
        $(this).toggleClass('open');
        $('.lang__wrapper').toggleClass('open');
    });
    $(".lang-select .lang-select__item").click(function() {
        $(this).siblings(".lang-select__item").removeClass('active');
        $(this).toggleClass('active');
        $(this).siblings(".lang-select  .lang__wrapper").removeClass('open');
    });

    /** Закрытие списка языков при клике вне его **/
    DOC.on('click', function(e) {
        if (!$(e.target).closest(".lang").length) {
            $('.lang-select').removeClass('open');
            $('.lang__wrapper').removeClass('open');
        }
        e.stopPropagation();
    });
    /** End **/

    /** Tabs + cookies / Profile transaction history **/
    function historySwitcher(e) {
        const historyDeposit = $('[data-history-deposit]');
        const historyDepositContent = $('[data-history-deposit-content]');
        const historywithdraw = $('[data-history-withdraw]');
        const historywithdrawContent = $('[data-history-withdraw-content]');
        historywithdraw.on('click', function () {
            historyDeposit.removeClass('active');
            historyDepositContent.removeClass('active');
            historywithdraw.addClass('active');
            historywithdrawContent.addClass('active');
            $.cookie('HistorySwitcher', 'history-withdraw', {path: '/'});
        });
        historyDeposit.on('click', function () {
            historywithdraw.removeClass('active');
            historywithdrawContent.removeClass('active');
            historyDeposit.addClass('active');
            historyDepositContent.addClass('active');
            $.cookie('HistorySwitcher', 'history-deposit', {path: '/'});
        });
    }
    historySwitcher();
    //-- End Tabs история транзакций

    // ADD cookies history transaction switcher
    function setHistoryView() {
        if ( $.cookie('HistorySwitcher') == null ) {
            $.cookie('HistorySwitcher', 'history-withdraw', {path: '/'});
        }
        if ( $.cookie('HistorySwitcher') == 'history-withdraw' ) {
            $('[data-history-withdraw]').click();
        }

        if ( $.cookie('HistorySwitcher') == 'history-deposit' ){
            $('[data-history-deposit]').click();
        }
    }
    setHistoryView();
    /** END tabs + cookies / Profile transaction history **/

    /**
     * Инициализация модального окна, inline type
     */

    $('[data-modal-inline]').magnificPopup({
        type:'inline',
        midClick: true
    });

    /** Событие срабатывает в случае успешного выполнения ajax запроса **/
    $(document).on('ajaxSuccess', function() {

        selectInit();
        lazyLoad();
        dateInit();
        /** Слайдер выбора бонуса на депозит в модалке **/
        chooseBonus();
    });

    /** Раскрытие фрейма с игрой на весь экран **/
    $('.game__panel-fullscreen').click(function () {
        $('.game__iframe iframe, .game__iframe img').fullscreen();
    });

	DOC.on("click", "[data-close-game-panel]", function() {
		$(this).parents(".game").toggleClass("hide-game-panel")
	});

	$('[data-input-captcha]').wrap('<div class="form__input--wrapper">');

	// ---- MOBILE menu -----------------

	$('[data-mobile-menu]').click(function (e) {
		$(this).toggleClass("opened");
		$('[data-mobile-menu-content]').toggleClass("visible");
	});

	// ----- Selectric 2 -----------------

	/** Инициализация select2 in modal **/
	function selectSearch() {
		$('[data-select-search]').each(function() {
			if (!$(this).hasClass('select2-hidden-accessible')) {
				$(this).select2({
					dropdownParent: $('.mfp-content .wrapping')
				});
			}
		});
	}
	selectSearch();

	$(document).on('ajaxSuccess', function() {
		selectSearch();
	});
	/** End **/

	/** Инициализация select2 in profile **/
	function selectSearchProfile() {
		$('[data-select-search-profile]').each(function() {
			if (!$(this).hasClass('select2-hidden-accessible')) {
				$(this).select2();
			}
		});
	}
	selectSearchProfile();
	/** End **/

	// ----- SPORT BOOK -----------------

	if ($('[data-sport-book]').length > 0) {
		HTML.addClass('page-sportbook');
	}

	// ----- BG fixed ---------------------

	function setbg() {
		var offset = 0;

		if ($(window).width() <= 1840 && $(window).width() >= 1281) {
			offset = 2932;
		} else if ($(window).width() <= 1280 && $(window).width() > 768) {
			offset = 2932;
	    } else if ($(window).width() <= 768 && $(window).width() > 640) {
	      offset = 2932;
		} else if ($(window).width() <= 640) {
			offset = 4436;
		} else {
			offset = 2932;
		}

		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

		if ($(this).scrollTop() + window.innerHeight > offset + 0 && !isSafari) {
			$('main').addClass("bg-fixed");
		}
		else {
			$('main').removeClass("bg-fixed");
		}
	}
	setbg();
	WIN.on('scroll', function () {
		setbg();
	});

    /**
     *  Табы в виде трансформера из табов в селекты
     *
     *    data-tabs - аттрибут, по которому происходит инициализация работы табов
     *
     *    data-tabs-save - аттрибут, который, фактически активирует сохранение активного таба в LocalStorage
     *        Для него нужно указать имя, которое будет использоваться для идентификации текущей страницы
     *
     *    data-tabs-sync - аттрибут, который активирует синхронизацию двух табов
     *        Его нужно задать для того селекта, С КОТОРЫМ нужно синхронизировать активный
     *        Если задать для обоих селектов - синхронизация будет работать в обе стороны
     *
     *    data-tabs-transform - аттрибут, значение в котороым указывает ширину экрана, меньше которой табы будут трансформироваться в селект
     *
     *    data-tabs-selector - аттрибут, добавляем его в случае, если нужно сделать выделение таба, которое с анимацией
     *        передвигается после выделения таба
     *
     * */
    function newTabs(){
        let tabs_active = 'active',
            tabs_content = '.tabs__content';

        $('[data-tabs]').each(function (){
            $(this).selectric({
                maxHeight: 200,
                disableOnMobile: false,
                nativeOnMobile: false,
                responsive: false,
                arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
            })
                .on('change', function(){
                    let tabs_parent = $(this).closest('.tabs__parent'),
                        tabs_save = $(this).closest('[data-tabs-save]'),
                        tabs_save_value = tabs_save.data('tabs-save'),
                        tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected'),
                        tab_counter = tabs_selected.index();

                    tabs_parent.find(tabs_content + ':first').parent().children(tabs_content).removeClass(tabs_active).eq(tab_counter).addClass(tabs_active);

                    // если указан дата аттрибут для сохранения - сохраняем его в localStorage
                    if(tabs_save.length && tabs_save_value.length){
                        localStorage.setItem(tabs_save_value, tab_counter);
                    }

                    // синхронизация двух селектов
                    // в случае сложной адаптивной структуры, если по дизайну селект (табы) переносятся в другой блок
                    $('[data-tabs-sync]').each(function (){
                        $(this).parents('.selectric-wrapper').find('li').removeClass('selected').eq(tab_counter).addClass('selected').trigger('click');
                    })


                    if($(this).closest('[data-tabs-selector]').length){
                        // добавляем координаты и ширину для выделения
                        $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                            "left": tabs_selected.position().left + "px",
                            "width": tabs_selected.innerWidth() + "px"
                        });
                    }

                });

            if($(this).closest('[data-tabs-selector]').length){
                // создаём элемент, который будет использоваться как выделение
                let tabs_current = $(this).parents('.selectric-wrapper').find('li.selected');
                $(this).parents('.selectric-wrapper').find('.selectric-scroll').prepend('<span class="tabs__select" style="width: ' + tabs_current.innerWidth() + 'px; left:' + tabs_current.position().left + 'px"></span>');
            }

            // находим общего родителя для табов и контена табов и проставляем классы
            let tabs_parent = $($(this).parents().get().find(itm => $(itm).find(tabs_content).length)),
                tabs_save = $(this).closest('[data-tabs-save]'),
                tabs_save_value = tabs_save.data('tabs-save');

            tabs_parent.addClass('tabs__parent');

            // если установлено сохранение активного таба - при загрузке страницы эмулируем клик на него
            if(tabs_save.length && tabs_save_value.length){
                setTimeout(function() {
                    tabs_save.parents('.selectric-wrapper').find('li:eq(' + localStorage.getItem(tabs_save_value) + ')').trigger('click');
                }, 1);
            }
        });
    }
    newTabs();

    // значение, при котором изменяется тип табов (табы или селект) задается в дата-аттрибут data-tabs-transform
    function tabsTypeCheck(){
        $('[data-tabs-transform]').each(function (){
            let windowWidth = $(this).data('tabs-transform');
            if(WIN.width() <= windowWidth){
                $(this).parents('.select').removeClass('select--tabs').addClass('select--transformed');
            }
            else{
                $(this).parents('.select').addClass('select--tabs').removeClass('select--transformed');
            }
        });
    }
    tabsTypeCheck();

    WIN.on('resize', function() {
        // проверка типа табов
        tabsTypeCheck();
    });

    /** End New tabs **/

    /** Search form **/

    function searchForm() {

        let searchInput = $('[data-search-form] input'),
            searchButton = $('[data-search-form] button'),
            searchVal = $.trim(searchInput.val());

        if (searchVal.length >= 1) {
            searchButton.attr('disabled', false);
        } else {
            searchButton.attr('disabled', true);
        }
        searchButton.on('click', function () {
            searchInput.val(searchVal);
        });

    }

    searchForm();

    $('[data-search-form] input').on('keyup',function(){
        searchForm();
    });

    /** End search form **/

});
